"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASYNC_EFFECT_EVENT_NAME = 'ASYNC_EFFECT_EVENT_NAME';
exports.ASYNC_RESULT_EVENT_NAME = 'ASYNC_RESULT_EVENT_NAME';
/** 异步队列变化事件 */
exports.ASYNC_STATUS_CHANGE_NAME = 'ASYNC_STATUS_CHANGE_NAME';
//# sourceMappingURL=consts.js.map